import { SponsorDetails } from '@/modals/sponsor/SponsorDetails';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

declare var bootstrap: any;

@Component({
  selector: 'app-sponsor',
  templateUrl: './sponsor.component.html',
  styleUrls: ['./sponsor.component.scss']
})
export class SponsorComponent implements OnInit {

 @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  sponsors: SponsorDetails[] = [];
  selectedSponsor: SponsorDetails | null = null;
  adminSponsorModal: boolean = false;
  newPaymentStatus: string = '';
  paymentSt: string = '';
  sponsorD!: number;
  destroy$ = new Subject<void>();
  sponsorType = '';
  sponsorAmount = 0;
  sponsorForm!: FormGroup;
  fileData: string | null = null;
  fileType: string | null = null;
  searchText: string = '';
  filteredSponsors: SponsorDetails[] = [];
  searchTerm: string = '';
  selectedStatus: string = '';


  addSponsorForm = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.required]),
    lastName: new UntypedFormControl('', [Validators.required]),
    emailAddress: new UntypedFormControl('', [Validators.required, Validators.email]),
    phoneNumber: new UntypedFormControl('', [Validators.required]),
    companyName: new UntypedFormControl('', [Validators.required]),
    location: new UntypedFormControl('', [Validators.required]),
    logo: new UntypedFormControl('', [Validators.required]),
    fileData: new UntypedFormControl('', [Validators.required]),
    fileType: new UntypedFormControl('', [Validators.required]),
    displayText: new UntypedFormControl('', [Validators.required]),
    paymentStatus: new UntypedFormControl('', [Validators.required]),
    sponsorType: new UntypedFormControl('', [Validators.required]),
    referenceType: new UntypedFormControl('sponsor', [Validators.required]), // Always "sponsor"
    amount: new UntypedFormControl('', [Validators.required]),
    updatedBy: new UntypedFormControl('', [Validators.required]),
    updateNote: new UntypedFormControl('', [Validators.required]),
  });

  addSponsorFormErrors: any = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    phoneNumber: '',
    companyName: '',
    location: '',
    logo: '',
    sponsorType: '',
    pamentStatus: '',
  };

  constructor(private appService: AppService,
    private toaster: ToastrService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private cdRef: ChangeDetectorRef,
    private router: Router) { }

  openModal() {
    this.addSponsorForm.patchValue({
      referenceType: 'sponsorship'
    });

    const modalElement = document.getElementById('sponsorModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const file = input.files[0];
    const ext = file.name.split('.').pop()?.toLowerCase();

    if (!ext || !['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png'].includes(ext)) {
      this.toaster.info('Only PDF and Word documents are allowed');
      this.addSponsorForm.patchValue({ resumePath: null });
      this.fileData = null;
      this.fileType = null;
      setTimeout(() => this.fileInput.nativeElement.value = '', 0);
      return;
    }

    this.fileType = ext;

    const reader = new FileReader();
    reader.onload = () => {
      this.fileData = (reader.result as string).split(',')[1];
      this.addSponsorForm.patchValue({
        fileData: this.fileData,
        fileType: this.fileType,
        resumePath: file.name
      });
    };

    reader.readAsDataURL(file);
  }

  onSubmit(): void {

    this.formValidation();


    // set amount based on sponsorType
    const selectedType = this.addSponsorForm.value.sponsorType;
    if (selectedType === 'Platinum') {
      this.addSponsorForm.patchValue({ amount: 500 });
    } else if (selectedType === 'Gold') {
      this.addSponsorForm.patchValue({ amount: 250 });
    } else if (selectedType === 'Silver') {
      this.addSponsorForm.patchValue({ amount: 100 });
    }

    console.log(this.addSponsorForm.value.paymentStatus);
    console.log('Submitting amount:', this.addSponsorForm.value.amount);

  }


  formValidation(): void {
    let hasError = false;
    Object.keys(this.addSponsorFormErrors).forEach(key => {
      this.addSponsorFormErrors[key] = '';
    });

    if (this.addSponsorForm.get('firstName')?.invalid) {
      this.addSponsorFormErrors.firstName = '*First name is required';
      hasError = true;
    }

    if (this.addSponsorForm.get('lastName')?.invalid) {
      this.addSponsorFormErrors.lastName = '*Last name is required';
      hasError = true;
    }

    if (this.addSponsorForm.get('emailAddress')?.invalid) {
      this.addSponsorFormErrors.emailAddress = '*Valid Email Address is required';
      hasError = true;
    }

    if (this.addSponsorForm.get('phoneNumber')?.invalid) {
      this.addSponsorFormErrors.phoneNumber = '*Phone Number is required';
      hasError = true;
    }

    if (this.addSponsorForm.get('companyName')?.invalid) {
      this.addSponsorFormErrors.companyName = '*Company Name is required';
      hasError = true;
    }

    if (this.addSponsorForm.get('location')?.invalid) {
      this.addSponsorFormErrors.location = '*Location is required';
      hasError = true;
    }

    if (this.addSponsorForm.get('logo')?.invalid) {
      this.addSponsorFormErrors.logo = '*Logo is required';
      hasError = true;
    }

    if (this.addSponsorForm.get('sponsorType')?.invalid) {
      this.addSponsorFormErrors.sponsorType = '*SponsorType is required';
      hasError = true;
    }

    if (this.addSponsorForm.get('paymentStatus')?.invalid) {
      this.addSponsorFormErrors.paymentStatus = '*Payment Status is missing';
    }


    if (!hasError) {
      console.log('Submitting Sponsor Form:', this.addSponsorForm.value);

    }

    if (!hasError) {
      // Set amount before saving
      const selectedType = this.addSponsorForm.get('sponsorType')?.value;
      if (selectedType === 'PLATINUM') {
        this.addSponsorForm.patchValue({ amount: 500 });
      } else if (selectedType === 'GOLD') {
        this.addSponsorForm.patchValue({ amount: 250 });
      } else if (selectedType === 'SILVER') {
        this.addSponsorForm.patchValue({ amount: 100 });
      }

      this.saveSponsorDetails();
    }
  }

  saveSponsorDetails(): void {
    this.spinner.show();
    this.cdRef.detectChanges(); // 👈 force UI update so spinner appears immediately

    this.appService.saveSponsorByAdmin(this.addSponsorForm.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.toaster.success('Your details were saved successfully!');
          this.addSponsorForm.reset({ referenceType: 'sponsorship' }); // keep referenceType
          this.router.navigate(['/main/admin-sponsor']);
        },
        error: (error) => {
          this.toaster.error(error.message || 'Something went wrong, please try again');
        },
        complete : () => {
          setTimeout(() => this.spinner.hide(),2000)
        },
      });
  }


  //admin view html functionality

  openingSponsor(): void {
    this.adminSponsorModal = !this.adminSponsorModal;
  }

  applyFilters() {
    this.filteredSponsors = this.sponsors.filter((sponsor) => {
      const matchesSearch = sponsor.companyName.toLowerCase().includes(this.searchTerm.toLowerCase()) || sponsor.emailAddress?.toLowerCase().includes(this.searchTerm.toLowerCase()) || sponsor.phoneNumber?.includes(this.searchTerm) || sponsor.sponsorType.includes(this.searchTerm);
      const matchesStatus = !this.selectedStatus || sponsor.paymentStatus === this.selectedStatus;
      
      return matchesSearch && matchesStatus 
    })
  }

  confirmPaymentUpdate() {
    if (!this.sponsorD || !this.newPaymentStatus) {  // use newPaymentStatus here
      console.error('Missing sponsor ID or payment status.');
      return;
    }

    const body = {
      sponsorDetailsId: this.sponsorD,
      paymentStatus: this.newPaymentStatus
    };

    this.spinner.show();

    this.appService.updateSponsorPaymentStatus(body).subscribe({
      next: () => {
        if (this.selectedSponsor) {
          this.selectedSponsor.paymentStatus = this.newPaymentStatus;
        }
        this.adminSponsorModal = false;
        this.loadSponsors();
        this.toaster.success('Payment status updated successfully.');
      },
      error: (err) => {
        console.error('Failed to update sponsor payment:', err);
      },
      complete: () => {
        setTimeout(() => this.spinner.hide(), 2000);
      }
    });
  }

  paymentUpdate(paymentStatus: string, sponsorDetailsId: number): void {
    this.adminSponsorModal = true;

    this.paymentSt = paymentStatus;
    this.sponsorD = sponsorDetailsId;
    this.newPaymentStatus = paymentStatus;

    this.selectedSponsor = this.sponsors.find(s => s.sponsorDetailsId === sponsorDetailsId) || null;
  }

  previewLogo(sponsorDetailsId: number) {
    if (!sponsorDetailsId) return;

    this.appService.getSponsorLogo(sponsorDetailsId).subscribe({
      next: (fileArrayBuffer: ArrayBuffer) => {
        let fileType = 'application/octet-stream';
        const arr = new Uint8Array(fileArrayBuffer.slice(0, 4));
        const header = arr.reduce((acc, curr) => acc + curr.toString(16), '');

        if (header.startsWith('25504446')) {
          fileType = 'application/pdf';
        } else if (header.startsWith('504b34')) {
          fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        } else if (header.startsWith('ffd8ff')) {
          fileType = 'image/jpeg';
        } else if (header.startsWith('89504e47')) {
          fileType = 'image/png';
        }

        const blob = new Blob([fileArrayBuffer], { type: fileType });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
      },
      error: () => {
        console.error('Unable to preview sponsor logo');
      }

    });
  }


  onStatusChange(event: Event, sponsorDetailsId: number, index: number): void {
    const newStatus = (event.target as HTMLSelectElement).value;

    this.spinner.show();

    this.appService.updateStatus(sponsorDetailsId, newStatus).subscribe({
      next: () => {
        console.log('Status updated');
        this.sponsors[index].status = newStatus;
      },
      error: (err) => {
        console.error('Failed to update status:', err);
      },
      complete: () => {
        setTimeout(() => this.spinner.hide(), 2000);
      }
    });
  }

  ngOnInit(): void {
    // ✅ Then: load sponsor data
    this.loadSponsors();
  }

  loadSponsors(): void {

    this.spinner.show();

    this.appService.getAllSponsors().subscribe({
      next: (data) => {
        this.sponsors = data.filter(
          sponsor => sponsor.referenceType?.toUpperCase() === 'SPONSORSHIP')
          .sort((a, b) => b.sponsorDetailsId - a.sponsorDetailsId);
         this.filteredSponsors = [...this.sponsors];
      },
      error: (err) => {console.error('Error loading Sponsors:', err);
      },
      complete: () => {
        setTimeout(() => this.spinner.hide(),2000);
      },   
    });
  }

  //  loadBannerImage(subEventId: number): void {
  //     this.appService.getBannerImage(subEventId)
  //       .pipe(takeUntil(this.destroy$))
  //       .subscribe({
  //         next: (blob: Blob) => {
  //           const url = window.URL.createObjectURL(blob);
  //           this.bannerImages[subEventId] = this.sanitizer.bypassSecurityTrustUrl(url);
  //         },
  //         error: (err) => {
  //           console.error(`Error loading banner for sub-event ${subEventId}:`, err);
  //         }
  //       });
  //   }
  
  //   getBannerImageUrl(subEventId: number): SafeUrl | null {
  //     return this.bannerImages[subEventId] || null;
  //   }

}
